import { DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutBuildRangeFAKProfile extends Layout {
    sourceBuildRangeFakProfile: DataSource;
    textboxActualHighClass: Textbox;
    textboxActualLowClass: Textbox;
    textboxRatedClass: Textbox;
}
